// extracted by mini-css-extract-plugin
module.exports = {"picture":"Picture-module--picture--3Qy_m"};